// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1Q2z_","size-sm":"styles_size-sm__lvyYx","size-md":"styles_size-md__20mPh","size-lg":"styles_size-lg__3c6KC","size-xl":"styles_size-xl__1P3wP"};